import { servicesAPI } from 'supporticon/utils/client'

export const authenticateUser = (charityId, token) =>
  servicesAPI.post(
    `/v1/justgiving/reports/${charityId}/authenticate`,
    {},
    {
      headers: {
        Authorization: `Basic ${token}`
      }
    }
  )

export const fetchFundraiserData = (
  charityId,
  eventId,
  startDate,
  endDate,
  token
) =>
  servicesAPI.get(`/v1/justgiving/reports/${charityId}/${eventId}/pages`, {
    params: {
      startDate,
      endDate
    },
    headers: {
      Authorization: `Basic ${token}`
    }
  })
    .then(response => response.data)
